class HttpUtils {
	/**
	 * Convierte un cadena query string a un objeto javascript.
	 *
	 * @param queryString
	 * @returns {any}
	 */
	queryStringToObject (queryString)
	{
		if ('object' === typeof queryString) return queryString;
		let response = queryString;
		
		try {
			let queryObject = {};
			let encodedQueryString 	= encodeURI(queryString);
			encodedQueryString 		= decodeURI(encodedQueryString);
			let params = new URLSearchParams(encodedQueryString);
			
			for (let [key, value] of params.entries()) {
				queryObject[key] = value;
			}
			response = queryObject;
		} catch (_) {
			// Shhhhh....
		}

		return response;
	}
}

export default new HttpUtils()